<template>
    <transition name="fade">
        <div class="Viewer3D" v-show="viewer3DVisible">
            <div class="v3-container">
                
                <!-- Toolbar -->
                <div class="v3-bar">
                    <p class="v3-bar-name">{{product.title}}</p>
                    <md-button class="md-icon-button v3-bar-close" @click="toggle3DViewer(false)" :md-ripple="false" :class="{'followModeratorDisableButton': followModeratorMode}">
                        <CloseIcon/>
                    </md-button>
                </div>

                <!-- Loadingscreen -->
                <div id="v3-viewer3D-loadingscreen" class="v3-viewer3D-loadingscreen">
                    <img class="v3-viewer3D-logo" :src="publicPath+'/media'+mediaURL+logoURL" alt="">
                    <div class="v3-viewer3D-text" id="v3-text">0%</div>
                    <svg class="v3-viewer3D-animation" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                        <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                            <animateTransform attributeName="transform" attributeType="XML"  type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                        </path>
                    </svg>
                </div>
                
                <!-- Sidebar -->
                <div class="v3-viewer3D-sidebar" :style="{right: (sidebarOpen && allLoaded) ? '0px' : '-30%', bottom: (allLoaded) ? '0px' : '-30%'}">
                    <div class="v3-viewer3D-sidebar-bestseller" v-if="product.bestseller">{{ $t('BESTSELLER') }}</div>
                    <div class="v3-viewer3D-sidebar-title">{{product.fullTitle}}</div>
                    <div class="v3-viewer3D-sidebar-bulletpoints" v-html="product.bulletpoints"/>
                    <div>
                        <md-button class="md-icon-button v3-viewer3D-sidebar-shop" @click="openShop(product.shopURL)" :md-ripple="false">
                            <img :src="publicPath+'/media'+mediaURL+'/data/icons/icShop.svg'" alt="">
                            <span>{{ $t('Im Shop ansehen') }}</span>
                        </md-button>
                    </div>
                    <div class="v3-viewer3D-sidebar-technicalData">{{ $t('TECHNISCHE DATEN') }}</div>
                    <table class="v3-viewer3D-sidebar-technicalData-table">
                        <tr v-for="data in product.technicalData" :key="data[0]">
                            <th>{{data.label}}</th>
                            <th>{{data.value}}</th>
                        </tr>
                    </table>
                    <img class="v3-viewer3D-sidebar-logo" :src="product.logo" alt="">
                </div>

                <div class="v3-viewer3D-content" :style="{width: (sidebarOpen && allLoaded) ? '70%' : '100%', height: (sidebarOpen && allLoaded) ? 'calc(100% - 70px)' : 'calc(100% - 70px)'}">

                    <!-- Canvas -->
                    <Canvas id="v3-viewer3D-canvas" class="v3-viewer3D-canvas"/>  

                    <!-- Product Size  -->
                    <transition name="product-fade">
                        <div class="v3-viewer3D-productSize" v-if="sizeComparisonOpen">
                            <div class="v3-viewer3D-productSize-title">{{ $t('PRODUKTMAßE') }}</div>
                            <div class="v3-viewer3D-productSize-value"><span style="font-weight: bold; margin-right: 5px;">B</span>{{product.width}}</div>
                            <div class="v3-viewer3D-productSize-value"><span style="font-weight: bold; margin-right: 5px;">T</span>{{product.depth}}</div>
                            <div class="v3-viewer3D-productSize-value"><span style="font-weight: bold; margin-right: 5px;">H</span>{{product.height}}</div>
                        </div>
                    </transition>

                    <!-- Buttons -->
                    <div class="v3-viewer3D-buttons">
                        <md-button class="md-icon-button v3-viewer3D-buttons-info" @click="toggleSidebar()" :md-ripple="false" :style="{background: sidebarOpen ? 'var(--deniosBlueSecondary)' : 'var(--primaryColor)'}" v-if="!noShop && allLoaded">
                            <img :src="publicPath + '/media'+mediaURL+'/data/icons/ic_info.png'" alt="" style="width: 100%; height: 100%;">
                        </md-button>
                    </div>
                </div>
                 
            </div>        
        </div>  
    </transition>
</template>
    
<script>
import {mapGetters,mapMutations,mapActions} from 'vuex';
import * as BABYLON from 'babylonjs';
import 'babylonjs-loaders';
import axios from 'axios';

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import KeyboardBackspace from 'vue-material-design-icons/KeyboardBackspace.vue'

export default {
    components: {CloseIcon,KeyboardBackspace},
    data: function () {
        return{
            publicPath: process.env.BASE_URL,
            viewer3DVisible: false, 
            title: "",
            product: "",
            sku: "",
            skuAlt: "",
            noShop: false,
            sidebarOpen: true,
            sizeComparisonOpen: false,

            allLoaded: false,
        }
    }, 
    computed: {
        ...mapGetters(['mediaURL','logoURL','activeLanguage','currentSituationID',"followModeratorMode","sendingFollowModerator","activeRegion"])
    },
    watch: {
        followModeratorMode(){
            if(this.followModeratorMode && this.viewer3DVisible)
                this.toggle3DViewer(false);
        },
    },
	methods: {
        ...mapActions(["sendCommand"]),
        ...mapMutations(["setDialogueOpen"]),
        toggleSizeComparison(){
            this.sizeComparisonOpen = !this.sizeComparisonOpen;
        },
        openShop(shopURL){
            // window.dispatchEvent(new CustomEvent("openURL",{detail:{type: "Website",content: {url: shopURL}}}));
            window.open(shopURL, '_blank').focus();
        },
        toggleSidebar(){
            this.sidebarOpen = !this.sidebarOpen;
        },
        toggle3DViewer(bool){
            if(this.sendingFollowModerator)
                this.sendCommand({type: "CommandSendEvent", data: {eventName: "openViewer3D", state: bool, content: this.product, sku: this.sku, noShop: this.noShop, skuAlt: this.skuAlt}});

            if(bool != this.viewer3DVisible){
                this.setDialogueOpen(bool);
                this.viewer3DVisible = bool;
                this.viewer3DVisible ? this.show3DViewer() : this.hide3DViewer();
            }
        },
        show3DViewer(){
            let meshURL = (this.publicPath == '.' ? '' : window.location.origin) + '/media'+ this.mediaURL+'/data/Products/' + this.sku + '/3DData/' + this.product.mesh;
            
            window.engine3DViewer.displayLoadingUI();

            // Load new Model
            BABYLON.SceneLoader.ImportMesh("","", meshURL, window.scene3DViewer, (meshes) =>{ // onSuccess
                meshes[0].name = this.sku+"_";

                // Configure Camera
                if(window.scene3DViewer.activeCamera){
                    // window.scene3DViewer.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline("ssao", window.scene3DViewer.activeCamera);
                    // window.scene3DViewer.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline("default", window.scene3DViewer.activeCamera);
                    window.scene3DViewer.activeCamera.dispose();
                }
                    
                window.scene3DViewer.createDefaultCamera(true,true,true);
                let camera =  window.scene3DViewer.activeCamera;
                camera.alpha = 1;
                camera.beta = 1;
                camera.lowerRadiusLimit = camera.radius * 0.3;
                camera.radius *= 0.9;
                camera.upperRadiusLimit = camera.radius * 1.7;
                camera.inputs.attached.pointers.buttons = [0,1];
                // window.scene3DViewer.postProcessRenderPipelineManager.attachCamerasToRenderPipeline("ssao", camera);
                // window.scene3DViewer.postProcessRenderPipelineManager.attachCamerasToRenderPipeline("default", camera);

                window.engine3DViewer.hideLoadingUI();
                window.engine3DViewer.runRenderLoop(()=> { window.scene3DViewer.render(); });

            },(evt) => { // onProgress
                var loadedPercent = 0;
                if(evt.lengthComputable){
                    loadedPercent = (evt.loaded * 100 / evt.total).toFixed();
                }else{
                    var dlCount = evt.loaded / (1024 * 1024);
                    loadedPercent = Math.floor(dlCount * 100.0) / 100.0;
                }
                document.getElementById("v3-text").innerHTML = loadedPercent + "%";
            });
        },
        hide3DViewer(){
            window.engine3DViewer.stopRenderLoop();

            // Clear Scene
            window.scene3DViewer.materials.forEach(material => { material.dispose(); });
            window.scene3DViewer.meshes.forEach(mesh => { mesh.dispose(); });

            // Hide other product menus
            window.dispatchEvent(new CustomEvent("closeOtherProductMenus", {detail:{this: undefined}}));
        },
        init3DViewer(){
            console.log("Init 3D Viewer for Product "+ this.sku);
            const canvas = document.getElementById("v3-viewer3D-canvas");
            window.engine3DViewer = new BABYLON.Engine(canvas, true, { stencil: true, xrCompatible: false });
            window.engine3DViewer.setHardwareScalingLevel(1 / window.devicePixelRatio);
            window.engine3DViewer.enableOfflineSupport = true;
            BABYLON.Database.IDBStorageEnabled = true;
            BABYLON.Engine.OfflineProviderFactory = (urlToScene, callbackManifestChecked, disableManifestCheck) => {
                return new BABYLON.Database(urlToScene, callbackManifestChecked, true);
            };

            function customLoadingScreen() {}
            customLoadingScreen.prototype.displayLoadingUI = function () {
                document.getElementById("v3-viewer3D-loadingscreen").style.opacity = 1;
            };
            customLoadingScreen.prototype.hideLoadingUI = function () {
                document.getElementById("v3-viewer3D-loadingscreen").style.opacity = 0;
            };
            window.engine3DViewer.loadingScreen = new customLoadingScreen();

            window.scene3DViewer = new BABYLON.Scene(window.engine3DViewer);
            window.scene3DViewer.environmentTexture = new BABYLON.CubeTexture("https://assets.babylonjs.com/environments/environmentSpecular.env", window.scene3DViewer); 
            window.scene3DViewer.clearColor = new BABYLON.Color4(0, 0, 0, 0);
            window.scene3DViewer.autoClear = false;
            // window.scene3DViewer.debugLayer.show();

            // this.initPipeline();

            // let light = new BABYLON.HemisphericLight("HemiLight", new BABYLON.Vector3(0, 1, 0), window.scene3DViewer);
            // light.intensity = 0.5;

            const resizeObserver = new ResizeObserver(() => {setTimeout(() => {window.engine3DViewer.resize(); }, 0); });
            resizeObserver.observe(canvas);
        },
        initPipeline(){
            // SSAO
            let ssao = new BABYLON.SSAO2RenderingPipeline("ssao", window.scene3DViewer, {
                ssaoRatio: 0.5, // Ratio of the SSAO post-process, in a lower resolution
                blurRatio: 1    // Ratio of the combine post-process (combines the SSAO and the scene)
            });
            ssao.radius = 1;
            ssao.totalStrength = 1.35;
            ssao.base = 0;
            ssao.samples = 16;
            ssao.maxZ = 600;
            ssao.minZAspect = 1;
            
            // Default Pipeline
            let defaultPipeline = new BABYLON.DefaultRenderingPipeline("default", true, window.scene3DViewer);
            defaultPipeline.samples = 16;

            // defaultPipeline.bloomEnabled = true;
            // defaultPipeline.bloomThreshold = 0.9;
            // defaultPipeline.bloomWeight = 0.1;
            // defaultPipeline.bloomKernel = 128;
            // defaultPipeline.bloomScale = 0.5;

            defaultPipeline.imageProcessing.imageProcessingConfiguration.toneMappingEnabled = false;
			// defaultPipeline.imageProcessing.toneMappingEnabled = false;
			// defaultPipeline.imageProcessing.contrast = 1.8;
			// defaultPipeline.imageProcessing.exposure = 2;
            // defaultPipeline.imageProcessing.imageProcessingConfiguration.toneMappingType = 1;
            // defaultPipeline.imageProcessing.colorCurvesEnabled = true;
            // defaultPipeline.imageProcessing.contrast = 2.0;
            // defaultPipeline.imageProcessing.exposure = 1.2;

            defaultPipeline.fxaaEnabled = true;
            defaultPipeline.sharpenEnabled = true;
        },
        async getProductJson(sku){  
            let tokenData = await axios("https://auth.europe-west1.gcp.commercetools.com/oauth/token?grant_type=client_credentials", {
                method: 'POST',
                headers: {
                    'Authorization': 'Basic czRuMTNzUjNqUnBpSUUzMmN3VnI5TzhmOkl4VVBkbDhiUEtEMWpNOE0xalNZUjBiWkFNR1BPVlhp'
                }
            }).catch(() => {
                console.log("error");
            })

            let productJson = await axios("https://api.europe-west1.gcp.commercetools.com/denios_develop/products/key="+sku, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + tokenData.data.access_token
                }
            }).catch(() => {
                console.log("error");
            })

            return productJson.data;
        }
    },
    mounted(){
        this.init3DViewer();

        window.addEventListener('openViewer3D', async (e) => {
            console.log("--->",e.detail);
            this.product = e.detail.content;
            this.sku = e.detail.sku;
            this.skuAlt = e.detail.skuAlt;
            this.noShop = e.detail.noShop;
            document.getElementById("v3-text").innerHTML = "0%";

            if(this.noShop){
                this.toggle3DViewer(e.detail.state == undefined ? true : e.detail.state);
                this.sidebarOpen = false;
                return;
            }

            this.sidebarOpen = true;
            let productJson = await this.getProductJson(this.sku);
            
            let lang = this.activeLanguage.shortCode + "-" + this.activeRegion.id;

            this.product.title = productJson.masterData.current.name[lang];
            this.product.fullTitle = productJson.masterData.current.name[lang];
            this.product.bulletpoints = productJson.masterData.current.description[lang];

            this.product.shopURL = this.activeRegion.homePage + productJson.masterData.current.slug[lang] + "/" + (this.skuAlt ? this.skuAlt : this.sku);

            let attributes = productJson.masterData.current.masterVariant.attributes;

            // Bestseller
            this.product.bestseller = attributes.find(attribut => attribut.name === 'CS_BADGE') != undefined;

            // Product-Logo
            if(attributes.find(attribut => attribut.name === 'brand_image')){
                let filename = JSON.parse(attributes.find(attribut => attribut.name === 'brand_image').value[lang])[0].filename;
                this.product.logo = "https://imageservice.production.denios.io/live-asset.denios-2020.de/brand/"+filename+"/inside:0x40.webp";
            }

            // Technische Daten
            this.product.technicalData = JSON.parse(attributes.find(attribut => attribut.name === "CS_TECHNISCHE_DATEN").value[lang]);

            // Check if all necessary infos are loaded
            this.allLoaded = (this.product.title != undefined && this.product.fullTitle !=  undefined && this.product.bulletpoints != undefined)

            this.product.title = this.product.title != undefined ? this.product.title :  productJson.masterData.current.name["en-GB"];

            this.toggle3DViewer(e.detail.state == undefined ? true : e.detail.state);
        });

        window.addEventListener('onUserJoined',() => {
            if(this.viewer3DVisible)
                this.sendCommand({type: "CommandSendEvent", data: {eventName: "openViewer3D", content: this.product, sku: this.sku, noShop: this.noShop, skuAlt: this.skuAlt}});
        });
    },
    destroyed(){
        console.log("destroyed");
        window.engine3DViewer.dispose();
    }
}

</script>

<style>
    .Viewer3D{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
        z-index: 10;
    }
    .v3-container{
        position: absolute;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        overflow: hidden;
        width: 90%;
        height: 90%;
        background: var(--deniosBackground);
    }

    /* Toolbar */
    .v3-bar{
        display: flex;
        position: relative;
        height: 70px;
        background: white;
    }
    .v3-bar-name{
        width: calc(100% - 50px);
        text-align: center;
        margin: auto 0;
        color: var(--deniosGraySecondary);
        font: normal normal 100 clamp(0.5rem, min(3vw,3vh) + 0.25rem, 1.4rem) Oswald;
    }
    .v3-bar-close{
        background: var(--primaryColor) !important;
        position: absolute;
        right: 0;
        padding: 5px;
        border-radius: 0;
        margin-right: 0;
        height: 100%;
        width: 50px !important;
    }
    .v3-bar-close::before, .v3-bar-back::before{
        border-radius: 0;
    }
    .material-design-icon{
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon > .material-design-icon__svg{
        fill: white;
        height: 2.5em;
        width: 2.5em;
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
        margin-left: 0;
    }
 

    /* 3D Viewer Content */
    .v3-viewer3D-content{
        position: relative; 
        display: flex;
        height: calc(100% - 70px);
        transition: width .6s ease;
    }
    .v3-viewer3D-canvas{
        width: 100%;
        height: 100% !important;
        outline: none;
    }
    .v3-viewer3D-buttons{
        position: absolute;
        bottom: 40px;
        left: calc(50% - 60px);
    }
    .v3-viewer3D-buttons-info, .v3-viewer3D-buttons-comparison{
        width: 50px;
        height: 50px;
    }
    .v3-viewer3D-buttons-comparison{
        margin-right: 20px;
    }

    /* Sizecomparison */
    .v3-viewer3D-productSize{
        position: absolute;
        bottom: 40px;
        left: 40px;
    }
    .v3-viewer3D-productSize-title{
        color: var(--deniosDark);
        font: normal normal 100 18px/31px Oswald;
        letter-spacing: 1.89px;
        margin-bottom: 10px;
    }
    .v3-viewer3D-productSize-value{
        font: normal normal 500 16px/24px Roboto;
        display: inline-block;
        margin-right: 30px;
    }

    /* Sidebar */
    .v3-viewer3D-sidebar{
        background: white;
        position: absolute;
        height: calc(100% - 70px);
        width: 30%;
        padding: 40px;
        padding-top: 50px;
        padding-bottom: 60px;
        right: -30%;
        transition: right .6s ease;
        overflow-y: auto;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
    }
    .v3-viewer3D-sidebar-bestseller{
        margin-bottom: 10px;
        color: var(--deniosDark);
        font: normal normal 100 14px/22px Oswald;
        letter-spacing: 1.35px;
    }
    .v3-viewer3D-sidebar-title{
        margin-bottom: 20px;
        font: normal normal 100 28px/31px Oswald;
        letter-spacing: 1.89px
    }
    .v3-viewer3D-sidebar ul{
        margin-top: 0;
        padding: 0;
        padding-left: 20px;
        font-weight: lighter;
        font: normal normal 500 16px/24px Roboto;
        margin-bottom: 50px;
    }
    .v3-viewer3D-sidebar li{
        margin-bottom: 5px;
        white-space: break-spaces;
        list-style-type: square;
    }
    .v3-viewer3D-sidebar li::marker{
        color: var(--primaryColor);
    }
    .v3-viewer3D-sidebar h2{
        font: normal normal 100 28px/31px Oswald;
        letter-spacing: 1.89px;
    }
    .v3-viewer3D-sidebar h3, .v3-viewer3D-sidebar p{
        font-weight: lighter;
        font: normal normal 500 16px/24px Roboto;
        margin-top: 0;
        margin-bottom: 20px;
    }
    .v3-viewer3D-sidebar-shop{
        background: white;
        width: 100%;
        outline: 2px solid var(--primaryColor);
        color: var(--primaryColor);
        margin-bottom: 40px;
        border-radius: 0;
    }
    .v3-viewer3D-sidebar-shop::before{
        border-radius: 0;
    }
    .v3-viewer3D-sidebar-shop img{
        width: 22px;
        height: 22px;
        margin-right: 10px;
    }
    .v3-viewer3D-sidebar-technicalData{
        color: var(--deniosDark);
        font: normal normal 100 16px/22px Oswald;
        letter-spacing: 1.35px;
        margin-bottom: 20px;
    }
    .v3-viewer3D-sidebar-technicalData-table{
        width: 100%;
        text-align: left;
    }
    .v3-viewer3D-sidebar-technicalData-table tr{
        color: #353535;
        font: normal normal 100 clamp(0.5rem, min(0.6vw,3vh) + 0.3em, 2rem) Roboto;
        font-weight: lighter;
    }
    .v3-viewer3D-sidebar-technicalData-table tr:nth-child(odd){
        background-color: var(--deniosGraySecondary);
    }
    .v3-viewer3D-sidebar-technicalData-table th{
        width: 50%;
        padding: 5px;
        font-weight: lighter;
    }
    .v3-viewer3D-sidebar-technicalData-table th:nth-child(even){
        color: var(--deniosDark);
        font-weight: bold;
    }
    .v3-viewer3D-sidebar-logo{
        margin-top: auto;
        margin-left: auto;
        padding-top: 50px;
        width: 25%;
    }

    /* Loadingscreen */
    .v3-viewer3D-loadingscreen{
        pointer-events: none;
        opacity: 0;
        transition: 1s opacity ease-in-out;
        position: absolute;
        width: 100%;
        height: 100%;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 6;
    }
    .v3-viewer3D-logo{
        width: 350px;
    }
    .v3-viewer3D-animation{
        fill: var(--primaryColor);
        width: 200px;
        height: 200px;
        display: block;
    }
    .v3-viewer3D-text{
        font-size: 24px;
        margin-top: 20px;
        color: var(--primaryColor);
        text-align: center;
        font-weight: bolder;
    }

    /* Fade Animation */
    .product-fade-enter-active, .product-fade-leave-active {
        transition: opacity .4s;
    }
    .product-fade-enter, .product-fade-leave-to {
        opacity: 0;
    }

    @media (width <= 1000px){
        .v3-viewer3D-sidebar{
            right: 0px !important;
            width: 100%;
            min-width: auto;
            height: 30%;
            padding: 20px;
        }
        .v3-container{
            display: flex;
            flex-direction: column;
        }
        .v3-viewer3D-content{
            position: absolute; 
            flex-direction: column-reverse;
            height: calc(70% - 70px) !important;
            width: 100% !important;
            top: 70px;
        }
        .v3-viewer3D-buttons{
            display: none;
        }
        .v3-viewer3D-sidebar-technicalData-table tr{
            font: normal normal 100 clamp(0.5rem, min(1.6vw,3vh) + 0.25rem, 1.2rem) Roboto;
        }
    }
</style>